/*
 * @Author: 刘枫 
 * @Date: 2021-04-26 11:02:50 
 * @Description: 公司新闻
 * @Last Modified by: liufeng
 * @Last Modified time: 2021-04-26 11:32:24
 */

<template>
  <div class="must-know-item" @click="jumpDetail(article)">
    <div class="item-info">
      <div class="item-info-title">
        <img :src="require('../../assets/images/business1.png')" alt="" width="18">
        <span>{{article.ftitle}}</span>
      </div>
      <div class="item-info-content">
        <div class="info-content-time">
          日期：{{article.fissuedate}}
        </div>
        <div class="info-content-watchers">
          <span class="iconfont iconchakan"></span>
          <span class="watchers-count">{{article.fhitsall}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MustKnowItem',
  props: {
    article: Object,
    title: String
  },
  data() {
    return {
    }
  },
  components: {
  },
  methods: {
    jumpDetail(article) {
      this.$router.push({
        path: '/guide/articleDetail',
        query: {
          title: this.title,
          fid: article.fid
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.must-know-item {
  padding: 13px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 1);
  border-bottom: 1px solid #e0e0e0;
  .item-img {
    width: 56px;
    .item-img-wrapper {
      width: 37px;
      height: 37px;
      background: rgba(37, 138, 55, 0.1);
      color: #2c82c9;
      border-radius: 18.5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .item-info {
    // width: calc(~"100% - 56px");
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item-info-title {
      font-size: 15px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #333;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      span {
        margin-left: 5px;
      }
    }
    .item-info-content {
      display: flex;
      // justify-content: space-between;
      .info-content-time {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      .info-content-watchers {
        margin-left: 10px;
        display: flex;
        align-items: center;
        .iconfont {
          color: #bbbbbb;
        }
        .watchers-count {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-left: 5px;
        }
      }
    }
  }
}
</style>